import React from 'react';

export const Duplicate = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.1545 13.1846C19.1545 13.9808 18.5083 14.627 17.7121 14.627H6.603C5.80678 14.627 5.16056 13.9808 5.16056 13.1846V3.94146C5.16056 3.14523 5.80678 2.49902 6.603 2.49902H17.7121C18.5083 2.49902 19.1545 3.14523 19.1545 3.94146V13.1846ZM17.7121 13.1846H6.603V3.94146H17.7121V13.1846ZM11.5025 7.79805V5.33206H12.945V7.79805H15.389V9.24048H12.945V11.7942H11.5025V9.24048H8.92577V7.79805H11.5025ZM14.3829 16.0578H3.28765V6.82623H4.44737V5.38379H3.28765C2.49143 5.38379 1.84521 6.03 1.84521 6.82623V16.0578C1.84521 16.854 2.49143 17.5003 3.28765 17.5003H14.3829C15.1791 17.5003 15.8253 16.854 15.8253 16.0578V15.3424H14.3829V16.0578Z"
      fill={color || '#6E6B8C'}
    />
  </svg>
);
